import React,{ useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/AiImageRecognition.css';
import VerticalSensorCard from './VerticalSensorCard';

import product3 from '../assets/akusense1.png'; // actual image path

const aiSensors = [
  {
    title: 'Vision Sensor',
    image: product3,
    points: [
      'Liquid focus technology',
      'Highly precise positioning algorithm and detection algorithm',
      'Modular solution with integrated light source',
      'Compact size for simple installation',
    ],
    link: '/products/VisionSensor',
  },
];

const AiImageRecognition = () => {

  return (
    <div className="ai-sensors-page">
      <Header />

      <section className="ai-sensors-hero">
        <h1>AI Image Recognition</h1>
        <p>Smart sensors designed for machine vision and recognition applications.</p>
      </section>

      <section className="sensor-grid">
        {aiSensors.map((sensor, index) => (
          <a href={sensor.link} key={index} className="sensor-card-link">
            <VerticalSensorCard
              image={sensor.image}
              title={sensor.title}
              points={sensor.points}
            />
          </a>
        ))}
      </section>

      <Footer />
    </div>
  );
};

export default AiImageRecognition;
